export const INITIAL = 'initial';
export const SMS = 'sms';
export const SUCCESS = 'success';
export const SUCCESS_WITH_REDIRECT = 'success_with_redirect';
export const ERROR = 'error';
export const PENDING = 'pending';
export const STEP_BY_STEP = 'step_by_step';

export const INN_TRUE = 'inn_true';
export const INN_FALSE = 'inn_false';

export const RESPONSE_REDIRECT_STATUSES = String(
    process.env.ALFALEASING_FORM_REDIRECT_STATUSES
).split(',');
export const RESPONSE_SUCCESS_STATUSES = String(
    process.env.ALFALEASING_FORM_SUCCESS_STATUSES
).split(',');

export const LK_HOST = process.env.ALFALEASING_LK_HOST;
